<template>
  <div class="cso-select"
       :class="{'is-error': validationErrors, 'is-active': isActive, 'is-filled': label && currentValue, 'is-disabled': disabled, 'no-label': !label}">

    <div class="cso-select-wrapper">
      <label v-if="label"
             :for="name">
        <span v-html="label"></span>
      </label>

      <select :id="name"
              :name="name"
              class="form-control"
              :class="customClass"
              v-model="currentValue"
              :disabled="disabled"
              :data-cy="cypressName"
              @focus="onFocus"
              @change="onInput"
              @blur="onBlur">
        <option v-for="(option, index) in options"
                :key="index"
                :value="option.value"
                :selected="option.value === currentValue">{{ option.title }}</option>
      </select>
      <i class="cso-select-icon arrow-icon vf-icon vf-icon-down" aria-label="Pfeil nach unten" role="img"></i>
    </div>

    <div class="cso-select-errors-wrapper"
         v-if="validationErrors && showValidationErrors">
      <div v-for="(error, index) in validationErrors"
           class="cso-select-error"
           v-html="error.message"
           :key="index">
      </div>
    </div>

  </div>
</template>
<script>
import validatedInputField from '@/mixins/validatedInputField'

export default {
  name: 'CsoSelect',
  mixins: [validatedInputField],
  data () {
    return {
      isActive: false
    }
  },

  props: {
    options: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    cypressName: {
      type: String,
      required: false
    },
    customClass: {
      type: String,
      default: ''
    }
  },
  methods: {
    onBlur (e) {
      this.isActive = false

      this.$emit('blur', e)
    },
    onFocus (e) {
      this.isActive = true

      this.$emit('focus', e)
    }
  }
}
</script>
<style lang="scss">
@import "./CsoInput";
</style>
